import { render, staticRenderFns } from "./galleryInfo.vue?vue&type=template&id=40907314&scoped=true&"
import script from "./galleryInfo.vue?vue&type=script&lang=js&"
export * from "./galleryInfo.vue?vue&type=script&lang=js&"
import style0 from "./galleryInfo.vue?vue&type=style&index=0&id=40907314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40907314",
  null
  
)

export default component.exports